import { render, staticRenderFns } from "./ArticleCreateEditForm.vue?vue&type=template&id=45e178a9&scoped=true&"
import script from "./ArticleCreateEditForm.vue?vue&type=script&lang=js&"
export * from "./ArticleCreateEditForm.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCreateEditForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ArticleCreateEditForm.vue?vue&type=style&index=1&id=45e178a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e178a9",
  null
  
)

export default component.exports